/* ============================================================================
   Vitaltees Ashwagandha PDP (t-ashwagandha) — interaction scripts
   ----------------------------------------------------------------------------
   Source: vitaltees-pdp-ashwagandha-v2.html (Claude Design handoff, 2026-06-09)
   Three IIFEs from the prototype, each isolated. All DOM lookups null-guarded
   so missing optional elements don't break the script (Lesson #3 from prior
   build: a single uncaught null.addEventListener broke ALL reveal animations).
   Reveal safety-net: setTimeout fallback makes content visible even if the
   IntersectionObserver fails for any reason.

   Dynamic --header-h: measures the real height of the .vt2-section--header
   wrapper and writes it to .vt2 so the sticky section-nav docks flush.
   ============================================================================ */

/* ====== Header-h via CSS (no JS sync) ======
   Previously, a JS resize handler measured the rendered header height and wrote
   it back into --header-h. That created a feedback loop on resize: the wrapper
   measures slightly taller than the row → JS writes the new value → header-row
   uses it as min-height → wrapper measures even taller → repeat. Result: menu
   visibly "grows" each time the viewport changes width.
   The CSS media queries (54px mobile / 64px from 768px) are authoritative. */


/* ====== Block #1 (lifted, null-guards applied) ====== */
(function(){
  'use strict';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mobile menu (guarded: header section may not be present) ---- */
  var menu = document.getElementById('mobileMenu');
  if (menu) {
    var menuToggle = document.getElementById('menuToggle');
    var menuClose = document.getElementById('menuClose');
    var lastFocus = null;
    var openMenu = function(){
      lastFocus = document.activeElement;
      menu.classList.add('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
      var f = menu.querySelector('a, button'); if(f) f.focus();
    };
    var closeMenu = function(){
      menu.classList.remove('is-open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded','false');
      document.body.style.overflow = '';
      if(lastFocus) lastFocus.focus();
    };
    if(menuToggle) menuToggle.addEventListener('click', openMenu);
    if(menuClose) menuClose.addEventListener('click', closeMenu);
    menu.querySelectorAll('[data-close]').forEach(function(a){ a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
      if(e.key === 'Tab' && menu.classList.contains('is-open')){
        var items = menu.querySelectorAll('a, button'); if(!items.length) return;
        var first = items[0], last = items[items.length-1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---- Smooth scroll for in-page anchors ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(id === '#' || id.length < 2) return;
      var target = document.querySelector(id);
      if(target){ e.preventDefault(); target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' }); }
    });
  });

  /* ---- Image gallery (guarded: hero may be absent or simplified) ---- */
  var mainImg = document.getElementById('galleryMainImg');
  var mainBlock = document.getElementById('galleryMain');
  var thumbStrip = document.querySelector('.gallery__thumbs');
  var mainTag = mainBlock ? mainBlock.querySelector('.media__tag') : null;
  var mainPrompt = mainBlock ? mainBlock.querySelector('.media__prompt') : null;
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery__thumb'));
  var galCurrent = 0;
  function animateScrollTo(target){
    if(!thumbStrip) return;
    var max = thumbStrip.scrollWidth - thumbStrip.clientWidth;
    target = Math.max(0, Math.min(max, target));
    if(Math.abs(target - thumbStrip.scrollLeft) < 1){ thumbStrip.scrollLeft = target; return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var start = thumbStrip.scrollLeft, t0 = null;
    if(reduce || typeof requestAnimationFrame !== 'function'){ thumbStrip.scrollLeft = target; return; }
    var dur = 300, ease = function(p){ return 1 - Math.pow(1 - p, 3); };
    var step = function(ts){ if(t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur); thumbStrip.scrollLeft = start + (target - start) * ease(p); if(p < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }
  function galScrollToActive(btn){
    if(!thumbStrip) return;
    var sr = thumbStrip.getBoundingClientRect(), br = btn.getBoundingClientRect();
    if(br.right > sr.right) animateScrollTo(thumbStrip.scrollLeft + (br.right - sr.right) + 12);
    else if(br.left < sr.left) animateScrollTo(thumbStrip.scrollLeft - (sr.left - br.left) - 12);
  }
  function thumbUnit(){
    if(thumbs.length < 2){ return thumbs.length ? thumbs[0].offsetWidth + 10 : 0; }
    return Math.abs(thumbs[1].getBoundingClientRect().left - thumbs[0].getBoundingClientRect().left);
  }
  function visibleThumbs(){
    if(!thumbStrip) return [];
    var sr = thumbStrip.getBoundingClientRect();
    return thumbs.filter(function(t){ var b = t.getBoundingClientRect(); return b.left >= sr.left - 2 && b.right <= sr.right + 2; });
  }
  function selectThumb(btn){
    thumbs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected','false'); });
    btn.classList.add('is-active'); btn.setAttribute('aria-selected','true');
    galCurrent = thumbs.indexOf(btn);
    var img = btn.getAttribute('data-img');
    var resId = btn.getAttribute('data-res');
    if(resId && window.__resources && window.__resources[resId]){ img = window.__resources[resId]; }
    if(mainTag) mainTag.textContent = btn.getAttribute('data-tag') || '';
    if(mainPrompt) mainPrompt.textContent = btn.getAttribute('data-prompt') || '';
    if(!mainImg) return;
    /* srcset wins over src in the browser; drop it so the swapped src shows. */
    if(img){ mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.setAttribute('src', img); mainImg.style.display = ''; }
    else { mainImg.removeAttribute('src'); mainImg.style.display = 'none'; }
  }
  function galStep(dir){
    if(!thumbs.length) return;
    var n = (galCurrent + dir + thumbs.length) % thumbs.length;
    selectThumb(thumbs[n]);
    galScrollToActive(thumbs[n]);
  }
  /* Clicking a thumbnail: show it big, and if it's one of the 2 edge-most VISIBLE
     thumbs, jump the strip to reveal new images on that side (clamped at the ends). */
  function onThumbClick(btn){
    var vis = visibleThumbs();
    var vi = vis.indexOf(btn);
    selectThumb(btn);
    if(vis.length > 2 && vi !== -1){
      var jump = thumbUnit() * 2;
      if(vi >= vis.length - 2){ animateScrollTo(thumbStrip.scrollLeft + jump); }
      else if(vi <= 1){ animateScrollTo(thumbStrip.scrollLeft - jump); }
    }
  }
  thumbs.forEach(function(btn){
    btn.addEventListener('click', function(){ onThumbClick(btn); });
    btn.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){ e.preventDefault(); galStep(1); thumbs[galCurrent].focus(); }
      if(e.key === 'ArrowLeft'){ e.preventDefault(); galStep(-1); thumbs[galCurrent].focus(); }
    });
  });
  /* Click the main image to advance: right half = next, left half = previous */
  if(mainBlock){
    mainBlock.classList.add('gallery__main--nav');
    mainBlock.addEventListener('click', function(e){
      if(e.target.closest('.gallery__arrow')) return;
      var r = mainBlock.getBoundingClientRect();
      galStep((e.clientX - r.left) > r.width / 2 ? 1 : -1);
    });
    var mkArrow = function(dir, label, d){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery__arrow gallery__arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      b.addEventListener('click', function(ev){ ev.stopPropagation(); galStep(dir === 'next' ? 1 : -1); });
      return b;
    };
    mainBlock.appendChild(mkArrow('prev','Vorheriges Bild','M15 18l-6-6 6-6'));
    mainBlock.appendChild(mkArrow('next','Nächstes Bild','M9 6l6 6-6 6'));
    /* Swipe (mobile): horizontal >40px und dominanter als vertikal → vor/zurück.
       Passive Listener; ein echter Swipe erzeugt keinen Klick, der Half-Tap bleibt. */
    var swipeX = null, swipeY = null;
    mainBlock.addEventListener('touchstart', function(e){
      if(e.touches.length !== 1){ swipeX = swipeY = null; return; }
      swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY;
    }, { passive: true });
    mainBlock.addEventListener('touchend', function(e){
      if(swipeX === null) return;
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      swipeX = swipeY = null;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) galStep(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---- Price + qty state (fixed product, no variant/purchase pickers) ----
     Real variant price comes from Shopify via data-price-cents on #atcPrice
     (set in vt2-mobile-atc.liquid). Never hardcode it here: the prototype's
     24,90 € overwrote the real 27,50 € on every page load. If the attribute
     is missing we leave the server-rendered price untouched. */
  var state = { qty: 1 };
  function fmt(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }
  var heroTotal = document.getElementById('heroTotal');
  var atcPrice = document.getElementById('atcPrice');
  var atcVariant = document.getElementById('atcVariant');
  var BASE_PRICE = null;
  if(atcPrice && atcPrice.dataset.priceCents){
    var parsed = parseInt(atcPrice.dataset.priceCents, 10);
    if(!isNaN(parsed) && parsed > 0) BASE_PRICE = parsed;
  }
  function refresh(){
    if(atcVariant) atcVariant.textContent = '30 Beutel · 150 g' + (state.qty > 1 ? (' · ' + state.qty + '×') : '');
    if(BASE_PRICE === null) return;
    var total = BASE_PRICE * state.qty;
    if(heroTotal) heroTotal.textContent = fmt(total);
    if(atcPrice) atcPrice.textContent = fmt(total);
  }

  /* hero add-to-cart confirmation */
  var pdpAtc = document.getElementById('pdpAtc');
  if(pdpAtc){
    pdpAtc.addEventListener('click', function(){
      if(pdpAtc.dataset.busy) return;
      pdpAtc.dataset.busy = '1';
      var label = pdpAtc.textContent;
      pdpAtc.textContent = 'Hinzugefügt ✓';
      setTimeout(function(){ pdpAtc.textContent = label; delete pdpAtc.dataset.busy; }, 1500);
    });
  }

  /* quantity (only when show_qty section setting is true — guarded).
     Also syncs the hidden `<input name="quantity">` inside the buy form so
     the AJAX add-to-cart submits the chosen quantity (otherwise always 1). */
  var qtyVal = document.getElementById('qtyVal');
  var qtyMinus = document.getElementById('qtyMinus');
  var qtyPlus = document.getElementById('qtyPlus');
  var qtyInput = document.getElementById('qtyInput');
  function setQty(n){
    state.qty = Math.max(1, Math.min(10, n));
    if(qtyVal) qtyVal.textContent = state.qty;
    if(qtyInput) qtyInput.value = state.qty;
    if(qtyMinus) qtyMinus.disabled = state.qty <= 1;
    if(qtyPlus) qtyPlus.disabled = state.qty >= 10;
    refresh();
  }
  if(qtyMinus) qtyMinus.addEventListener('click', function(){ setQty(state.qty - 1); });
  if(qtyPlus) qtyPlus.addEventListener('click', function(){ setQty(state.qty + 1); });
  refresh();

  /* ---- Sticky ATC bar visibility (header is sticky via CSS wrapper) ---- */
  var header = document.getElementById('siteHeader');
  var atc = document.getElementById('atcBar');
  var hero = document.getElementById('hero');
  if(atc && hero){
    var ticking = false;
    var onScroll = function(){
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var heroBottom = hero.getBoundingClientRect().bottom;
      var doc = document.documentElement;
      var nearBottom = (window.innerHeight + y) > (doc.scrollHeight - 160);
      if(heroBottom < 80 && !nearBottom){ atc.classList.add('is-visible'); atc.setAttribute('aria-hidden','false'); document.body.classList.add('has-atc-space'); }
      else { atc.classList.remove('is-visible'); atc.setAttribute('aria-hidden','true'); document.body.classList.remove('has-atc-space'); }
      ticking = false;
    };
    window.addEventListener('scroll', function(){ if(!ticking){ window.requestAnimationFrame(onScroll); ticking = true; } }, { passive:true });
    onScroll();
  }

  /* ---- Section nav: sticky shadow + active highlight (guarded) ---- */
  var sectionNav = document.getElementById('sectionNav');
  if(sectionNav){
    var navLinks = sectionNav.querySelectorAll('a');
    var watched = document.querySelectorAll('[data-section]');
    var navRow = sectionNav.querySelector('.section-nav__row');

    /* When an anchor becomes active, scroll the nav-row horizontally so the
       active anchor sits centered in the visible area. CSS at sub-768 already
       compresses the 5 anchors to fit at 360px+; this auto-scroll is the
       safety net for 320px viewports and for the future case where someone
       adds a 6th anchor that pushes total width past viewport. */
    function centerActiveAnchor(a){
      if(!navRow || !a) return;
      if(navRow.scrollWidth <= navRow.clientWidth) return; /* fits, nothing to do */
      var target = a.offsetLeft - (navRow.clientWidth / 2) + (a.offsetWidth / 2);
      target = Math.max(0, Math.min(target, navRow.scrollWidth - navRow.clientWidth));
      try { navRow.scrollTo({ left: target, behavior: 'smooth' }); }
      catch(_){ navRow.scrollLeft = target; } /* old browsers fall back */
    }

    if('IntersectionObserver' in window){
      var navIo = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            var id = en.target.getAttribute('data-section');
            var newlyActive = null;
            navLinks.forEach(function(l){
              var on = l.getAttribute('data-target') === id;
              l.classList.toggle('is-active', on);
              if(on) newlyActive = l;
            });
            if(newlyActive) centerActiveAnchor(newlyActive);
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
      watched.forEach(function(s){ navIo.observe(s); });
    }
  }

  /* ---- FAQ accordion (one-at-a-time) ---- */
  document.querySelectorAll('.faq-item').forEach(function(item){
    var trigger = item.querySelector('.faq-question');
    var answer = item.querySelector('.faq-answer');
    if(!trigger || !answer) return;
    trigger.addEventListener('click', function(){
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item.is-open').forEach(function(el){
        el.classList.remove('is-open');
        el.querySelector('.faq-question').setAttribute('aria-expanded','false');
        el.querySelector('.faq-answer').style.maxHeight = null;
      });
      if(!isOpen){
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded','true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* ---- Layout-variant switchers (design exploration) ---- */
  document.querySelectorAll('.vswitch').forEach(function(sw){
    var group = sw.getAttribute('data-vgroup');
    var stack = document.querySelector('.vstack[data-vgroup="' + group + '"]');
    if(!stack) return;
    sw.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        sw.querySelectorAll('button').forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-selected','false'); });
        b.classList.add('is-active'); b.setAttribute('aria-selected','true');
        var v = b.getAttribute('data-v');
        stack.querySelectorAll('.vpanel').forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-v') === v); });
      });
    });
  });

  /* ---- Generic inner tab groups (spotlight, timeline circles/stepper) ---- */
  document.querySelectorAll('[data-tabs]').forEach(function(group){
    var tabs = group.querySelectorAll('[data-tab]');
    var panels = group.querySelectorAll('[data-tabpanel]');
    var hover = group.hasAttribute('data-hover');
    function activate(key){
      tabs.forEach(function(t){ var on = t.getAttribute('data-tab') === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
      panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-tabpanel') === key); });
    }
    tabs.forEach(function(t){
      t.addEventListener('click', function(){ activate(t.getAttribute('data-tab')); });
      if(hover) t.addEventListener('mouseenter', function(){ activate(t.getAttribute('data-tab')); });
    });
  });

  /* ---- Timeline stepper fill ---- */
  document.querySelectorAll('.tlstep').forEach(function(st){
    var fill = st.querySelector('[data-fill]');
    var nodes = st.querySelectorAll('.tlstep__node');
    function setFill(i){ if(fill) fill.style.width = (nodes.length > 1 ? (i/(nodes.length-1))*100 : 0) + '%'; }
    nodes.forEach(function(n, i){ n.addEventListener('click', function(){ setFill(i); }); });
    setFill(0);
  });

  /* ---- Benefit accordion (one-at-a-time) ---- */
  document.querySelectorAll('.bacc').forEach(function(acc){
    acc.querySelectorAll('.bacc__q').forEach(function(q){
      q.addEventListener('click', function(){
        var item = q.closest('.bacc__item');
        var ans = item.querySelector('.bacc__a');
        var open = item.classList.contains('is-open');
        acc.querySelectorAll('.bacc__item.is-open').forEach(function(el){
          el.classList.remove('is-open'); el.querySelector('.bacc__a').style.maxHeight = null;
          el.querySelector('.bacc__q').setAttribute('aria-expanded','false');
        });
        if(!open){ item.classList.add('is-open'); ans.style.maxHeight = ans.scrollHeight + 'px'; q.setAttribute('aria-expanded','true'); }
      });
    });
  });

  /* ---- Horizontal image accordion (one-at-a-time) ---- */
  document.querySelectorAll('.hacc').forEach(function(h){
    h.querySelectorAll('.hacc__item').forEach(function(item){
      var spine = item.querySelector('.hacc__spine');
      if(!spine) return;
      spine.addEventListener('click', function(){
        h.querySelectorAll('.hacc__item').forEach(function(x){ x.classList.remove('is-open'); });
        item.classList.add('is-open');
      });
    });
  });

  /* ---- Reveal on scroll ---- */
  var revealEls = document.querySelectorAll('.reveal');
  function revealAll(){ revealEls.forEach(function(el){ el.classList.add('is-in'); }); }
  if(!prefersReduced && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el){ io.observe(el); });
    /* Reveal anything already in the initial viewport right away */
    revealEls.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < window.innerHeight && r.bottom > 0){ el.classList.add('is-in'); io.unobserve(el); }
    });
    /* Safety net: never leave content invisible if the observer misbehaves */
    setTimeout(revealAll, 1200);
  } else {
    revealAll();
  }

  /* ---- Newsletter (front-end confirmation only; using Shopify customer form
         in our section means this branch is mostly a no-op, but guarded anyway) ---- */
  var nForm = document.getElementById('newsletterForm');
  var nMsg = document.getElementById('newsletterMsg');
  if(nForm){
    nForm.addEventListener('submit', function(e){
      var input = nForm.querySelector('input[type="email"]');
      if(!input) return;
      e.preventDefault();
      if(input.checkValidity()){
        nForm.reset();
        if(nMsg){ nMsg.textContent = 'Danke, bitte bestätige die E-Mail in deinem Postfach.'; nMsg.style.color = 'var(--success)'; }
      } else {
        if(nMsg){ nMsg.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; nMsg.style.color = 'var(--error)'; }
        input.focus();
      }
    });
  }
})();

/* ====== Block #2 (lifted, null-guards applied) ====== */
/* ===== Round 3 · variant interactions (PDP) ===== */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* Heiß/Kalt method tabs + toggle */
  document.querySelectorAll('[data-hkroot]').forEach(function(root){
    root.querySelectorAll('[data-hk]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var m = btn.getAttribute('data-hk');
        root.querySelectorAll('[data-hk]').forEach(function(b){ b.classList.toggle('is-on', b===btn); });
        root.querySelectorAll('[data-hkpane]').forEach(function(p){ p.classList.toggle('is-on', p.getAttribute('data-hkpane')===m); });
        var tog = root.querySelector('.hk-toggle'); if(tog){ tog.setAttribute('data-pos', m); }
      });
    });
  });

  /* Mobile carousels · pagination dots */
  document.querySelectorAll('.r3-carousel').forEach(function(track){
    var dots = track.parentElement.querySelector('.r3-dots');
    if(!dots || dots.dataset.built) return;
    var items = track.children;
    dots.dataset.built = '1';
    for(var i=0;i<items.length;i++){ var s=document.createElement('span'); if(i===0) s.className='is-on'; dots.appendChild(s); }
    track.addEventListener('scroll', function(){
      var per = track.scrollWidth / items.length;
      var idx = Math.round(track.scrollLeft / per);
      idx = Math.max(0, Math.min(items.length-1, idx));
      [].forEach.call(dots.children, function(d,i){ d.classList.toggle('is-on', i===idx); });
    }, {passive:true});
  });

  /* Ingredients · fold-open (one at a time, guarded) */
  document.querySelectorAll('[data-foldgroup]').forEach(function(group){
    var items = group.querySelectorAll('.ingfold__item');
    items.forEach(function(item){
      var q = item.querySelector('.ingfold__q');
      var a = item.querySelector('.ingfold__a');
      if(!q || !a) return;
      q.addEventListener('click', function(){
        var open = item.classList.contains('is-open');
        items.forEach(function(it){
          it.classList.remove('is-open');
          var qq=it.querySelector('.ingfold__q'); if(qq) qq.setAttribute('aria-expanded','false');
          var aa=it.querySelector('.ingfold__a'); if(aa) aa.style.maxHeight='0px';
        });
        if(!open){ item.classList.add('is-open'); q.setAttribute('aria-expanded','true'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  });

  /* Ingredients · flip cards (tap toggles on touch) */
  document.querySelectorAll('[data-flipgroup] .ingflip__card').forEach(function(card){
    card.addEventListener('click', function(){
      var on = card.getAttribute('aria-pressed') === 'true';
      card.setAttribute('aria-pressed', String(!on));
    });
  });

  /* Ingredients · modal */
  var modal = document.getElementById('ingModal');
  if(modal){
    var lastTrigger = null;
    function openIng(data){
      document.getElementById('ingModalTag').textContent = data.tag || '';
      document.getElementById('ingModalName').textContent = data.name || '';
      document.getElementById('ingModalLatin').textContent = data.latin || '';
      document.getElementById('ingModalDose').textContent = data.dose ? 'Dosis · ' + data.dose : '';
      document.getElementById('ingModalDesc').textContent = data.desc || '';
      document.getElementById('ingModalSrc').textContent = data.src || '';
      document.getElementById('ingModalPrompt').textContent = data.name || 'Foto';
      modal.hidden = false; modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeIng(){ modal.classList.remove('is-open'); modal.hidden = true; document.body.style.overflow=''; if(lastTrigger) lastTrigger.focus(); }
    document.querySelectorAll('[data-ingmodal] [data-ing]').forEach(function(btn){
      btn.addEventListener('click', function(){
        lastTrigger = btn;
        try{ openIng(JSON.parse(btn.getAttribute('data-ing'))); }catch(e){}
      });
    });
    modal.querySelectorAll('[data-ingclose]').forEach(function(el){ el.addEventListener('click', closeIng); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && modal.classList.contains('is-open')) closeIng(); });
  }

  /* Layout-variant switchers · localStorage persistence */
  document.querySelectorAll('.vswitch[data-vgroup]').forEach(function(sw){
    var key = 'vt-r3pdp-' + sw.getAttribute('data-vgroup');
    var saved; try{ saved = localStorage.getItem(key); }catch(e){}
    if(saved){ var b = sw.querySelector('button[data-v="'+saved+'"]'); if(b && !b.classList.contains('is-active')) b.click(); }
    sw.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){ try{ localStorage.setItem(key, b.getAttribute('data-v')); }catch(e){} });
    });
  });
})();

/* ====== Block #3 (lifted, null-guards applied) ====== */
(function(){
  document.querySelectorAll('[data-navdrop]').forEach(function(drop){
    var btn = drop.querySelector('.nav-drop__btn');
    if(!btn) return;
    if(btn.tagName === 'BUTTON'){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var open = drop.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function(e){
      if(!drop.contains(e.target)){ drop.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); }
    });
    drop.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ drop.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); btn.focus(); }
    });
  });
  document.querySelectorAll('[data-mdrop]').forEach(function(drop){
    var btn = drop.querySelector('.m-drop__btn');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var open = drop.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

/* ============================================================================
   Cart badge live updates
   ----------------------------------------------------------------------------
   Horizon's <product-form-component> dispatches a `cart:update` event on the
   document after every successful AJAX add. We listen, read the new item
   count from the event detail (CartAddEvent.detail.data.itemCount), and
   refresh every `[data-cart-badge]` element on the page. Fallback: if the
   event doesn't carry a count, fetch /cart.js to get the authoritative one.
   Also triggers a brief pop animation on the cart icon.
   ============================================================================ */
(function(){
  function updateBadge(count){
    document.querySelectorAll('[data-cart-badge]').forEach(function(b){
      b.textContent = count > 99 ? '99+' : String(count);
      b.hidden = !(count > 0);
    });
  }
  function pop(){
    document.querySelectorAll('.icon-btn[aria-label="Warenkorb"]').forEach(function(btn){
      btn.classList.remove('cart-pop');
      void btn.offsetWidth;
      btn.classList.add('cart-pop');
    });
  }
  function refreshFromServer(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ if(c && typeof c.item_count === 'number') updateBadge(c.item_count); })
      .catch(function(){});
  }
  document.addEventListener('cart:update', function(e){
    var data = e && e.detail && e.detail.data;
    if(data && typeof data.itemCount === 'number'){
      updateBadge(data.itemCount);
    } else {
      refreshFromServer();
    }
    pop();
  });
})();

/* ============================================================================
   Homepage blocks (vitaltees-home-v2.html lift, 2026-06-09)
   ----------------------------------------------------------------------------
   Each block is its own IIFE so failures stay isolated. Every DOM lookup is
   null-guarded so these are inert on PDPs (where the elements don't exist).
   ----------------------------------------------------------------------------
   Note on overlap with existing blocks above:
   - Mobile menu, smooth-scroll, FAQ accordion, reveal-on-scroll, newsletter,
     [data-hkroot] toggle (covers both PDP `.hk-toggle` and homepage `.hk-a`
     since both share the data-hkroot/data-hk/data-hkpane attributes),
     `.r3-carousel` + `.r3-dots` pagination, nav megamenu, cart badge, and
     the generic `.vswitch` group switcher are all already implemented above
     and fire on any page where the matching elements exist.
   - PDP scroll handler at line ~227 requires `#atcBar` + `#hero` so it stays
     dormant on the homepage; the homepage uses its own scroll handler below
     for `#siteHeader.is-compact` and `#stickyCta` visibility.
   ============================================================================ */

/* ============================================================================
   Homepage: sticky header compact + sticky CTA visibility
   ============================================================================ */
(function(){
  'use strict';
  var stickyCta = document.getElementById('stickyCta');
  if (!stickyCta) return; /* PDP has no #stickyCta → bail */
  var header = document.getElementById('siteHeader');
  var ticking = false;
  function onScroll(){
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var doc = document.documentElement;
    var nearBottom = (window.innerHeight + y) > (doc.scrollHeight - 240);
    stickyCta.classList.toggle('is-visible', y > 700 && !nearBottom);
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if (!ticking){ window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  onScroll();
})();

/* ============================================================================
   Homepage: hero attr-host variant switcher (.vswitch[data-attrhost])
   Sets data-herov on the target element so CSS variants can toggle.
   ============================================================================ */
(function(){
  'use strict';
  var switches = document.querySelectorAll('.vswitch[data-attrhost]');
  if (!switches.length) return;
  switches.forEach(function(sw){
    var hostSel = sw.getAttribute('data-attrhost');
    if (!hostSel) return;
    var host = document.querySelector(hostSel);
    if (!host) return;
    sw.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        sw.querySelectorAll('button').forEach(function(x){
          x.classList.remove('is-active');
          x.setAttribute('aria-selected', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-selected', 'true');
        host.setAttribute('data-herov', b.getAttribute('data-v') || '');
      });
    });
  });
})();

/* ============================================================================
   Homepage: animated counters ([data-counter] = target integer)
   Counts up from 0 to target over 1.4s when scrolled into view.
   ============================================================================ */
(function(){
  'use strict';
  var counters = document.querySelectorAll('[data-counter]');
  if (!counters.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  counters.forEach(function(el){
    var target = parseInt(el.getAttribute('data-counter'), 10) || 0;
    var done = false;
    function run(){
      if (done) return; done = true;
      if (reduce){ el.textContent = target.toLocaleString('de-DE'); return; }
      var start = null, dur = 1400;
      function step(ts){
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        el.textContent = Math.floor(p * target).toLocaleString('de-DE');
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('de-DE');
      }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) run(); });
      }, { threshold: 0.4 });
      io.observe(el);
    } else {
      run();
    }
  });
})();

/* ============================================================================
   Homepage: reviews arrow carousel (.rev-carousel)
   Prev/next arrows scroll .rev-track by one card width (incl. gap).
   Disables arrows at the start/end of the scrollable range.
   ============================================================================ */
(function(){
  'use strict';
  var carousels = document.querySelectorAll('.rev-carousel');
  if (!carousels.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  carousels.forEach(function(car){
    var track = car.querySelector('.rev-track');
    var prev = car.querySelector('.rev-arrow--prev');
    var next = car.querySelector('.rev-arrow--next');
    if (!track || !prev || !next) return;
    function stepSize(){
      var card = track.querySelector('.review-card');
      var gap = parseInt(getComputedStyle(track).gap, 10) || 24;
      return card ? card.getBoundingClientRect().width + gap : 320;
    }
    function update(){
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function(){
      track.scrollBy({ left: -stepSize(), behavior: reduce ? 'auto' : 'smooth' });
    });
    next.addEventListener('click', function(){
      track.scrollBy({ left: stepSize(), behavior: reduce ? 'auto' : 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

/* ============================================================================
   Homepage: vswitch localStorage persistence (key prefix `vt-r3-`)
   PDP variant uses `vt-r3pdp-` (block #2 above). We persist independently.
   Note: the click handlers themselves live in the generic `.vswitch` block
   near the top — this block only adds save/restore on top of them.
   ============================================================================ */
(function(){
  'use strict';
  var switches = document.querySelectorAll('.vswitch[data-vgroup]');
  if (!switches.length) return;
  switches.forEach(function(sw){
    var group = sw.getAttribute('data-vgroup');
    if (!group) return;
    var key = 'vt-r3-' + group;
    var saved = null;
    try { saved = localStorage.getItem(key); } catch(e){}
    if (saved){
      var b = sw.querySelector('button[data-v="' + saved + '"]');
      if (b && !b.classList.contains('is-active')) b.click();
    }
    sw.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click', function(){
        try { localStorage.setItem(key, btn.getAttribute('data-v')); } catch(e){}
      });
    });
  });
})();

/* ============================================================================
   Homepage: quiz state machine (3 steps → result with primary + optional secondary SKU)
   ----------------------------------------------------------------------------
   Q1 (data-sku):  fokus | ruhe | energie  → primary SKU
   Q2 (data-time): morgens | mittags | abends | ganztags → timing tip
   Q3 (data-sku2): fokus | ruhe | energie → optional secondary SKU
   Result renders 1 card (or 2 if Q3 differs from Q1) + intro + timing tip.
   Mood image (#quizMood) cycles quiz-1/2/3 keys; section-side Liquid will
   inject the actual asset URLs via window.__resources lookup.
   ============================================================================ */
(function(){
  'use strict';
  var quizBody = document.getElementById('quizBody');
  if (!quizBody) return; /* not on homepage → skip */
  var quizResult = document.getElementById('quizResult');
  if (!quizResult) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Result cards are pre-rendered by the section's Liquid using REAL product
     data from Shopify (title, image, price, URL). We just toggle visibility
     based on the quiz state. Names come from window.__resources.quizNames
     (also Liquid-emitted) so the result label/tip mention the right product
     even if the editor changes which product is linked. */
  var QUIZ_NAMES = (window.__resources && window.__resources.quizNames) || {
    fokus: "Lion's Mane",
    ruhe:  'Ashwagandha',
    energie: 'Rhodiola'
  };
  /* Short name for the timing-tip sentence — falls back to first word of the
     full title, e.g. "Lion's Mane Aufguss" → "Lion's Mane". */
  function shortName(key){
    var full = QUIZ_NAMES[key];
    if (!full) return '';
    var m = full.match(/^([^A-Z]*[A-Z][^A-Z]*[A-Z]?[^A-Z]*)/);
    return (m ? m[1] : full.split(' ')[0]).replace(/\s+Aufguss\s*$/i, '').trim();
  }

  var PRIMARY_INTRO = {
    fokus:   'Für klares Denken und langfristige mentale Stärke.',
    ruhe:    'Für innere Ruhe und neues Gleichgewicht.',
    energie: 'Für klare Gedanken in fordernden Phasen.'
  };
  var SECONDARY = {
    fokus_ruhe:    'Bei hohem Stresslevel könnte Ashwagandha dein Abend-Begleiter sein.',
    fokus_energie: 'An Sporttagen ist Rhodiola eine gute Ergänzung.',
    ruhe_fokus:    "An Arbeitstagen passt Lion's Mane gut dazu.",
    ruhe_energie:  'An aktiven Tagen ist Rhodiola eine gute Ergänzung.',
    energie_fokus: "Für konzentrierte Stunden am Schreibtisch passt Lion's Mane dazu.",
    energie_ruhe:  'Für ruhige Abende ist Ashwagandha eine gute Ergänzung.'
  };
  function timingTip(time, name){
    switch(time){
      case 'morgens':  return 'Du trinkst morgens am liebsten Tee. ' + name + ' passt perfekt zum Start in den Tag.';
      case 'mittags':  return 'Mittags ist eine gute Zeit für ' + name + '. Auf einen Kaffee verzichten und stattdessen vier Minuten Pause.';
      case 'abends':   return 'Du magst Tee am Abend. ' + name + ' hilft dir, den Tag bewusst abzuschließen.';
      case 'ganztags': return 'Du magst Tee über den Tag verteilt. Tipp: Einen Beutel in einer Kanne aufgießen und auffüllen.';
      default: return '';
    }
  }
  function quizScrollTo(el, center){
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var top = window.pageYOffset + rect.top - (center ? Math.max(0, (window.innerHeight - rect.height) / 2) : 80);
    window.scrollTo({ top: top, behavior: prefersReduced ? 'auto' : 'smooth' });
  }
  function quizRes(id, fallback){
    return (window.__resources && window.__resources[id]) ? window.__resources[id] : fallback;
  }

  var quizState = { 1: null, 2: null, 3: null };
  var quizSteps = document.querySelectorAll('.quiz-step');
  var quizDots = document.querySelectorAll('#quizProgress .quiz__dot');
  var elLabel = document.getElementById('quizResultLabel');
  var elIntro = document.getElementById('quizResultIntro');
  var elCards = document.getElementById('quizResultCards');
  var elTip   = document.getElementById('quizResultTip');
  var quizMood = document.getElementById('quizMood');
  /* Mood keys: section Liquid will pre-populate window.__resources with the
     Shopify asset URLs (e.g. vt2-quiz-1.jpg) under these IDs. */
  var QUIZ_MOOD_FALLBACK = { 1: 'img/quiz-1.png', 2: 'img/quiz-2.png', 3: 'img/quiz-3.png' };
  var QUIZ_MOOD_IDS = { 1: 'quiz1', 2: 'quiz2', 3: 'quiz3' };

  function showStep(n){
    quizSteps.forEach(function(s){ s.classList.toggle('is-active', +s.dataset.step === n); });
    quizDots.forEach(function(d, i){ d.classList.toggle('is-done', i < n); });
    if (quizMood && QUIZ_MOOD_FALLBACK[n]){
      quizMood.src = quizRes(QUIZ_MOOD_IDS[n], QUIZ_MOOD_FALLBACK[n]);
    }
  }
  /* Show/hide pre-rendered cards by their data-quiz-sku attribute.
     Adds .sku-card--secondary to the second one when mixed mode. */
  function showCards(primaryKey, secondaryKey){
    if (!elCards) return;
    var cards = elCards.querySelectorAll('[data-quiz-sku]');
    var mixed = !!secondaryKey && secondaryKey !== primaryKey;
    cards.forEach(function(c){
      var key = c.getAttribute('data-quiz-sku');
      var isPrimary   = key === primaryKey;
      var isSecondary = mixed && key === secondaryKey;
      if (isPrimary || isSecondary){
        c.removeAttribute('hidden');
        c.classList.toggle('sku-card--secondary', isSecondary);
      } else {
        c.setAttribute('hidden', '');
        c.classList.remove('sku-card--secondary');
      }
    });
    elCards.classList.toggle('has-secondary', mixed);
  }

  function renderResult(){
    var primaryKey = quizState[1] || 'fokus';
    var secKey = quizState[3];
    var pName = QUIZ_NAMES[primaryKey];
    if (!pName) return;
    var mixed = !!secKey && secKey !== primaryKey && !!QUIZ_NAMES[secKey];

    if (elLabel) elLabel.textContent = 'Dein Aufguss: ' + pName;

    var intro = PRIMARY_INTRO[primaryKey] || '';
    if (mixed){
      var sentence = SECONDARY[primaryKey + '_' + secKey];
      if (sentence) intro += ' ' + sentence;
    }
    if (elIntro) elIntro.textContent = intro;

    showCards(primaryKey, mixed ? secKey : null);

    if (elTip) elTip.textContent = timingTip(quizState[2], shortName(primaryKey));

    quizBody.style.display = 'none';
    quizDots.forEach(function(d){ d.classList.add('is-done'); });
    if (quizMood) quizMood.src = quizRes('quiz3', 'img/quiz-3.png');
    quizResult.classList.add('is-active');
    if (!prefersReduced) quizScrollTo(quizResult, true);
  }

  document.querySelectorAll('.quiz-option').forEach(function(opt){
    opt.addEventListener('click', function(){
      var q = +opt.dataset.q;
      var step = opt.closest('.quiz-step');
      if (step){
        step.querySelectorAll('.quiz-option').forEach(function(o){ o.classList.remove('is-selected'); });
      }
      opt.classList.add('is-selected');
      quizState[q] = opt.dataset.sku || opt.dataset.time || opt.dataset.sku2 || null;
      setTimeout(function(){
        if (q < 3) showStep(q + 1);
        else renderResult();
      }, 220);
    });
  });

  var quizRestart = document.getElementById('quizRestart');
  if (quizRestart){
    quizRestart.addEventListener('click', function(){
      quizState = { 1: null, 2: null, 3: null };
      document.querySelectorAll('.quiz-option.is-selected').forEach(function(o){
        o.classList.remove('is-selected');
      });
      /* Hide all pre-rendered result cards again until next result. */
      if (elCards){
        elCards.querySelectorAll('[data-quiz-sku]').forEach(function(c){
          c.setAttribute('hidden', '');
          c.classList.remove('sku-card--secondary');
        });
        elCards.classList.remove('has-secondary');
      }
      quizResult.classList.remove('is-active');
      quizBody.style.display = '';
      showStep(1);
      quizScrollTo(document.getElementById('quiz'), false);
    });
  }
})();
